import ImageUploadMultiple from '../../src/legacy/ImageUploadMultiple.tsx';
export default ImageUploadMultiple;
